export default function AppointmentSchedulingForm() {
  return null;
}